module.exports = __webpack_public_path__ + "img/PCLawNEW.e48f6b0f.jpg";